import EntityExportHandler from 'common/entity/generic/EntityExportHandler';
import {
    platformEntitiesExport as platformEntitiesExportApi,
    platformEntitiesExportStatus as platformEntitiesExportStatusApi
} from 'common/middleware/api';

export default class PlatformEntityExportHandler extends EntityExportHandler {
    constructor() {
        super();
        this.exportApi = platformEntitiesExportApi;
        this.exportStatusApi = platformEntitiesExportStatusApi;
    }
}
